<template>
  <AppContainer v-if="showSocials" class="my-[50px]">
    <section class="w-full">
      <div
        class="rounded-3xl px-6 py-10 lg:py-16 bg-cover bg-center bg-no-repeat text-white flex flex-col lg:flex-row justify-between items-center"
        :class="['bg-[url(@/assets/images/insta-bg-mobile.webp)]', 'lg:bg-[url(@/assets/images/insta-bg.webp)]']"
      >
        <div class="flex justify-center mb-8 lg:mb-0 lg:w-1/2 xl:w-2/5">
          <img
            src="@/assets/images/insta-bubble.webp"
            alt="Social bubble"
            class="-mt-8 lg:mt-0 max-w-[320px] lg:max-w-[420px]"
          />
        </div>

        <div class="text-center lg:w-1/2 xl:w-3/5">
          <h2 class="text-white font-bold text-4xl lg:text-6xl leading-tight mb-4 text-center">
            Follow us on social media for the latest news and <br /> tips!
          </h2>

          <div class="flex justify-center">
            <a href="https://www.instagram.com/layup_payments/" target="_blank" rel="noopener noreferrer">
              <Button type="button" size="lg" class="px-6 py-3 mt-2 bg-brand-600 mx-auto"> Follow us </Button>
            </a>
          </div>
        </div>
      </div>

      <!-- Social Icons | using SVG's because lucid doesn't do brand logos -->
      <div class="flex justify-center gap-10 mt-12 text-brand-600">
        <a href="https://www.tiktok.com/@layup_payments" target="_blank" aria-label="TikTok" class="w-6 h-6">
          <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M38.2797 0H2.01472C1.48038 0 0.967931 0.212264 0.590098 0.590098C0.212264 0.967931 0 1.48038 0 2.01472V38.2797C0 38.814 0.212264 39.3265 0.590098 39.7043C0.967931 40.0821 1.48038 40.2944 2.01472 40.2944H38.2797C38.814 40.2944 39.3265 40.0821 39.7043 39.7043C40.0821 39.3265 40.2944 38.814 40.2944 38.2797V2.01472C40.2944 1.48038 40.0821 0.967931 39.7043 0.590098C39.3265 0.212264 38.814 0 38.2797 0ZM31.6694 17.5784C31.4498 17.6006 31.2282 17.6107 31.0086 17.6127C29.8132 17.6142 28.6363 17.3179 27.5842 16.7506C26.5321 16.1832 25.6379 15.3626 24.9825 14.3629V25.4298C24.9829 27.0482 24.5034 28.6303 23.6045 29.9761C22.7056 31.3219 21.4278 32.3709 19.9327 32.9904C18.4376 33.6099 16.7924 33.7721 15.2051 33.4565C13.6178 33.1409 12.1597 32.3616 11.0154 31.2172C9.871 30.0728 9.09172 28.6148 8.77609 27.0275C8.46045 25.4402 8.62265 23.795 9.24216 22.2999C9.86167 20.8047 10.9107 19.5269 12.2565 18.6281C13.6023 17.7292 15.1844 17.2496 16.8028 17.25C16.974 17.25 17.1392 17.2662 17.3085 17.2762V21.3057C16.7448 21.2374 16.1731 21.2851 15.6285 21.4459C15.084 21.6066 14.578 21.8771 14.1418 22.2406C13.7056 22.604 13.3483 23.0529 13.092 23.5595C12.8356 24.0661 12.6855 24.6198 12.651 25.1866C12.6164 25.7533 12.6982 26.3211 12.8911 26.8552C13.0841 27.3892 13.3842 27.8781 13.7731 28.2918C14.1619 28.7056 14.6313 29.0354 15.1523 29.2611C15.6733 29.4868 16.235 29.6036 16.8028 29.6043C17.9233 29.6246 19.007 29.2043 19.8208 28.4338C20.6347 27.6633 21.1136 26.6042 21.1546 25.4842L21.1949 6.68484H25.051C25.2271 8.35999 25.9865 9.91993 27.1963 11.0918C28.4062 12.2638 29.9895 12.9731 31.6694 13.0957V17.5784Z"
              fill="#1BBCC0"
            />
          </svg>
        </a>
        <a href="https://www.instagram.com/layup_payments/" target="_blank" aria-label="Instagram" class="w-6 h-6">
          <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M28.9492 0C35.0974 0.000112568 40.083 4.9866 40.083 11.1348V28.9492C40.0829 35.0973 35.0973 40.0829 28.9492 40.083H11.1348C4.98659 40.083 8.48495e-05 35.0974 0 28.9492V11.1348C0 4.98653 4.98653 0 11.1348 0H28.9492ZM20.042 8.90723C13.8938 8.90723 8.90723 13.8938 8.90723 20.042C8.90736 26.1901 13.8938 31.1758 20.042 31.1758C26.19 31.1756 31.1756 26.19 31.1758 20.042C31.1758 13.8939 26.1901 8.90739 20.042 8.90723ZM20.041 13.3604C23.7305 13.3604 26.7217 16.3515 26.7217 20.041C26.7217 23.7305 23.7305 26.7217 20.041 26.7217C16.3515 26.7217 13.3604 23.7305 13.3604 20.041C13.3604 16.3515 16.3515 13.3604 20.041 13.3604ZM33.4043 4.45312C32.1752 4.45321 31.1777 5.45152 31.1777 6.68066C31.178 7.9096 32.1753 8.90714 33.4043 8.90723C34.6333 8.90723 35.6306 7.90965 35.6309 6.68066C35.6309 5.45146 34.6335 4.45312 33.4043 4.45312Z"
              fill="#1BBCC0"
            />
          </svg>
        </a>
        <a
          href="https://za.linkedin.com/company/layup-technologies"
          target="_blank"
          aria-label="Linkedin"
          class="w-6 h-6"
        >
          <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M35.6289 0C38.0894 0.000183612 40.082 1.99359 40.082 4.4541V35.6299C40.0818 38.0902 38.0893 40.0828 35.6289 40.083H4.45312C1.99264 40.083 0.000204999 38.0903 0 35.6299V4.4541C4.59458e-06 1.99349 1.99252 2.59431e-05 4.45312 0H35.6289ZM7.74121 31.1768H13.3594V15.5889H7.74121V31.1768ZM17.9951 15.5889V31.1768H23.6133V22.6572C23.6133 20.1214 25.425 19.7579 25.9688 19.7578C26.5121 19.7578 27.9619 20.3013 27.9619 22.6572V31.1768H33.4004V22.6572C33.4004 17.7652 31.2246 15.5891 28.5059 15.5889C25.787 15.5889 24.337 16.4954 23.6133 17.7646V15.5889H17.9951ZM10.6426 7.38672C8.73421 7.38673 7.58984 8.531 7.58984 10.0586C7.58987 11.5861 8.73638 12.7304 10.4531 12.7305C12.3615 12.7305 13.5058 11.5862 13.5059 10.0586C13.5059 8.531 12.3595 7.38672 10.6426 7.38672Z"
              fill="#1BBCC0"
            />
          </svg>
        </a>
        <a href="https://www.facebook.com/LayUpPayments/" target="_blank" aria-label="Facebook" class="w-6 h-6">
          <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.29923 0H37.9837C39.1933 0 40.283 1.08962 40.283 2.29923V37.9837C40.283 39.1934 39.1933 40.283 37.9837 40.283H2.29923C1.08962 40.283 0 39.1934 0 37.9837V2.29923C0 1.08962 1.08962 0 2.29923 0ZM28.6068 22.6188H34.171L34.413 17.2965H28.6068V13.3657C28.6068 11.8542 28.9087 11.0065 30.8441 11.0065H34.231L34.353 6.04612C34.353 6.04612 32.8414 5.8042 30.6641 5.8042C25.3418 5.8042 22.9826 9.13112 22.9826 12.7V17.2965H19.0519V22.6188H22.9826V37.376H28.6068V22.6188Z"
              fill="#1BBCC0"
            />
          </svg>
        </a>
      </div>
    </section>
  </AppContainer>

  <footer class="lg:border-t border-grey-light-200 bg-base-white">
    <div class="max-w-content mx-auto py-12 lg:py-16 max-sm:px-6 max-xl:px-13">
      <!-- Mobile Accordion View -->
      <div class="lg:hidden">
        <div v-for="(section, index) in footerLinks" :key="`mobile-${index}`">
          <button
            @click="toggleSection(index)"
            class="w-full py-4 flex justify-between items-center text-left"
            :aria-expanded="activeIndex === index"
          >
            <span class="text-grey-light-700 font-medium">{{ section.title }}</span>
            <svg
              class="w-4 h-4 text-grey-light-500 transition-transform duration-200"
              :class="{ 'rotate-180': activeIndex === index }"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <Transition name="accordion">
            <ul v-if="activeIndex === index" class="space-y-3 p-0! pb-4">
              <li v-for="(link, linkIndex) in section.links" :key="linkIndex">
                <component
                  :is="isExternal(link.to) ? 'a' : 'RouterLink'"
                  v-bind="getBindProps(link.to)"
                  class="text-primary text-sm block py-1 transition-colors duration-200 cursor-pointer"
                >
                  {{ link.name }}
                </component>
              </li>
            </ul>
          </Transition>
        </div>
      </div>

      <!-- Desktop Grid View -->
      <div class="hidden lg:grid lg:grid-cols-4 gap-12">
        <div v-for="(section, index) in footerLinks" :key="`desktop-${index}`" class="flex flex-col">
          <h3 class="text-grey-light-600 font-medium text-sm mb-4">{{ section.title }}</h3>
          <ul class="space-y-3 p-0!">
            <li v-for="(link, linkIndex) in section.links" :key="linkIndex">
              <component
                :is="isExternal(link.to) ? 'a' : 'RouterLink'"
                v-bind="getBindProps(link.to)"
                class="text-primary text-sm transition-colors duration-200 inline-block cursor-pointer"
              >
                {{ link.name }}
              </component>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="border-t border-grey-light-200 bg-grey-light-25">
      <div class="max-w-content mx-auto max-sm:px-4 py-6">
        <div class="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <RouterLink to="/" class="flex items-center group">
            <img :src="layupLogo" alt="Layup Logo" class="h-12 lg:h-10 w-auto" />
          </RouterLink>
          <div class="flex items-center gap-6 text-brand-600">
            <a href="https://www.tiktok.com/@layup_payments" target="_blank" aria-label="TikTok" class="w-6 h-6">
              <svg class="w-full h-full" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M38.2797 0H2.01472C1.48038 0 0.967931 0.212264 0.590098 0.590098C0.212264 0.967931 0 1.48038 0 2.01472V38.2797C0 38.814 0.212264 39.3265 0.590098 39.7043C0.967931 40.0821 1.48038 40.2944 2.01472 40.2944H38.2797C38.814 40.2944 39.3265 40.0821 39.7043 39.7043C40.0821 39.3265 40.2944 38.814 40.2944 38.2797V2.01472C40.2944 1.48038 40.0821 0.967931 39.7043 0.590098C39.3265 0.212264 38.814 0 38.2797 0ZM31.6694 17.5784C31.4498 17.6006 31.2282 17.6107 31.0086 17.6127C29.8132 17.6142 28.6363 17.3179 27.5842 16.7506C26.5321 16.1832 25.6379 15.3626 24.9825 14.3629V25.4298C24.9829 27.0482 24.5034 28.6303 23.6045 29.9761C22.7056 31.3219 21.4278 32.3709 19.9327 32.9904C18.4376 33.6099 16.7924 33.7721 15.2051 33.4565C13.6178 33.1409 12.1597 32.3616 11.0154 31.2172C9.871 30.0728 9.09172 28.6148 8.77609 27.0275C8.46045 25.4402 8.62265 23.795 9.24216 22.2999C9.86167 20.8047 10.9107 19.5269 12.2565 18.6281C13.6023 17.7292 15.1844 17.2496 16.8028 17.25C16.974 17.25 17.1392 17.2662 17.3085 17.2762V21.3057C16.7448 21.2374 16.1731 21.2851 15.6285 21.4459C15.084 21.6066 14.578 21.8771 14.1418 22.2406C13.7056 22.604 13.3483 23.0529 13.092 23.5595C12.8356 24.0661 12.6855 24.6198 12.651 25.1866C12.6164 25.7533 12.6982 26.3211 12.8911 26.8552C13.0841 27.3892 13.3842 27.8781 13.7731 28.2918C14.1619 28.7056 14.6313 29.0354 15.1523 29.2611C15.6733 29.4868 16.235 29.6036 16.8028 29.6043C17.9233 29.6246 19.007 29.2043 19.8208 28.4338C20.6347 27.6633 21.1136 26.6042 21.1546 25.4842L21.1949 6.68484H25.051C25.2271 8.35999 25.9865 9.91993 27.1963 11.0918C28.4062 12.2638 29.9895 12.9731 31.6694 13.0957V17.5784Z"
                  fill="#1BBCC0"
                />
              </svg>
            </a>
            <a href="https://www.instagram.com/layup_payments/" target="_blank" aria-label="Instagram" class="w-6 h-6">
              <svg class="w-full h-full" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M28.9492 0C35.0974 0.000112568 40.083 4.9866 40.083 11.1348V28.9492C40.0829 35.0973 35.0973 40.0829 28.9492 40.083H11.1348C4.98659 40.083 8.48495e-05 35.0974 0 28.9492V11.1348C0 4.98653 4.98653 0 11.1348 0H28.9492ZM20.042 8.90723C13.8938 8.90723 8.90723 13.8938 8.90723 20.042C8.90736 26.1901 13.8938 31.1758 20.042 31.1758C26.19 31.1756 31.1756 26.19 31.1758 20.042C31.1758 13.8939 26.1901 8.90739 20.042 8.90723ZM20.041 13.3604C23.7305 13.3604 26.7217 16.3515 26.7217 20.041C26.7217 23.7305 23.7305 26.7217 20.041 26.7217C16.3515 26.7217 13.3604 23.7305 13.3604 20.041C13.3604 16.3515 16.3515 13.3604 20.041 13.3604ZM33.4043 4.45312C32.1752 4.45321 31.1777 5.45152 31.1777 6.68066C31.178 7.9096 32.1753 8.90714 33.4043 8.90723C34.6333 8.90723 35.6306 7.90965 35.6309 6.68066C35.6309 5.45146 34.6335 4.45312 33.4043 4.45312Z"
                  fill="#1BBCC0"
                />
              </svg>
            </a>
            <a href="https://www.youtube.com/@layuptechnologies" target="_blank" aria-label="YouTube" class="w-6 h-6">
              <svg class="w-full h-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M23.498 6.186a2.994 2.994 0 0 0-2.112-2.12C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.386.566a2.994 2.994 0 0 0-2.112 2.12A31.36 31.36 0 0 0 .5 12a31.36 31.36 0 0 0 .002 5.814 2.994 2.994 0 0 0 2.112 2.12C4.5 20.5 12 20.5 12 20.5s7.5 0 9.386-.566a2.994 2.994 0 0 0 2.112-2.12A31.36 31.36 0 0 0 23.5 12a31.36 31.36 0 0 0-.002-5.814zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"
                  fill="#1BBCC0"
                />
              </svg>
            </a>
            <a href="https://www.facebook.com/LayUpPayments/" target="_blank" aria-label="Facebook" class="w-6 h-6">
              <svg class="w-full h-full" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.29923 0H37.9837C39.1933 0 40.283 1.08962 40.283 2.29923V37.9837C40.283 39.1934 39.1933 40.283 37.9837 40.283H2.29923C1.08962 40.283 0 39.1934 0 37.9837V2.29923C0 1.08962 1.08962 0 2.29923 0ZM28.6068 22.6188H34.171L34.413 17.2965H28.6068V13.3657C28.6068 11.8542 28.9087 11.0065 30.8441 11.0065H34.231L34.353 6.04612C34.353 6.04612 32.8414 5.8042 30.6641 5.8042C25.3418 5.8042 22.9826 9.13112 22.9826 12.7V17.2965H19.0519V22.6188H22.9826V37.376H28.6068V22.6188Z"
                  fill="#1BBCC0"
                />
              </svg>
            </a>
            <p class="text-grey-light-500 text-sm text-center sm:text-right">
              © {{ currentYear }} Layup Technologies. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
import layupLogo from '@/assets/images/layup-logo.svg';
import { useThemeStore } from '@/stores/theme';
import { computed, ref } from 'vue';
import { RouterLink } from 'vue-router';
import { DASHBOARDS_URL } from '../config';
import AppContainer from './AppContainer.vue';
import { Button } from './ui/button';

const { showSocials } = defineProps({
  showSocials: { type: Boolean, default: false },
});

const themeStore = useThemeStore();

const currentYear = computed(() => new Date().getFullYear());

const activeIndex = ref<number | null>(null);

const toggleSection = (index: number) => {
  activeIndex.value = activeIndex.value === index ? null : index;
};

const isExternal = (to: any) => {
  if (typeof to === 'string') {
    return /^https?:\/\//.test(to);
  }
  return false;
};

const getBindProps = (to: any) => {
  if (isExternal(to)) {
    return { href: to, target: '_blank', rel: 'noopener noreferrer' };
  }
  // If it's a string, treat it as a route name
  if (typeof to === 'string') {
    return { to: { name: to } };
  }
  // If it's an object, use it directly as the route location
  return { to };
};

const signIn = computed(() => `${DASHBOARDS_URL}/shopper/auth/sign-in`);

const businessSection = {
  title: 'Business',
  links: [
    { name: 'Lay-By', to: 'layby-product' },
    { name: 'Save Now, Buy Later', to: 'save-now-buy-later-product' },
    { name: 'Pricing', to: 'business-pricing-layby' },
    { name: "FAQ's", to: 'business-faq' },
    { name: 'Blog', to: 'business-blog' },
  ],
};

const shopperSection = {
  title: 'Shopper',
  links: [
    { name: 'Shops', to: 'layby-stores' },
    { name: 'Sign In', to: signIn.value },
    { name: 'Support', to: 'shopper-contact-us' },
    { name: 'Help Center', to: 'help-center' },
    { name: 'Blog', to: 'shopper-blog' },
  ],
};
const integrationsSection = {
  title: 'Integrations',
  links: [
    { name: 'Developers', to: 'layby-business-integrations' },

    { name: 'API Documentation', to: 'https://documentation.layup.co.za/#layup-api-documentation' },
    { name: 'WooCommerce Plugin', to: { name: 'layby-business-plugin-woocommerce' } },
    { name: 'Magento Plugin', to: { name: 'layby-business-plugin-magento' } },
    { name: 'Shopify Plugin', to: { name: 'layby-business-plugin-shopify' } },
  ],
};

const aboutSection = {
  title: 'About Us',
  links: [
    { name: 'About Us', to: 'about-us' },
    { name: 'Careers', to: 'business-careers' },
    { name: 'Contact Us', to: 'shopper-contact-us' },
  ],
};

const footerLinks = computed(() => {
  const firstSection = themeStore.mode === 'business' ? businessSection : shopperSection;
  const secondSection = themeStore.mode === 'business' ? shopperSection : businessSection;
  return [firstSection, secondSection, integrationsSection, aboutSection];
});
</script>
